// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__19uyM","col":"CardReaderDesc_col__-hLqz","label":"CardReaderDesc_label__1QWGz"};